import { Button, Typography } from '@styles';
import styled, { css } from 'styled-components';

export const StyledTypography = styled(Typography)`
  ${({ title }) => css`
    font-weight: ${title ? 700 : 500};
    font-size: ${title ? 28 : 14}px;
    line-height: ${title ? 30 : 22}px;
    ${title && 'text-transform: uppercase;'}
  `}
`;

export const StyledButton = styled(Button)`
  background-color: black;
  color: white;
  border-radius: 8px;
  height: auto;
  padding: 22px 57px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
`;

export const getDataFromLS = (dataName) =>
  JSON.parse(localStorage.getItem(dataName));

export const setDataToLS = (dataName, data) => {
  localStorage.setItem(dataName, JSON.stringify(data));
};
